import { useCallback, useState } from 'react';

import { customApi } from '@utils';

const useFetchTutorial = () => {
  const [tutorial, setTutorial] = useState(null);
  const [tutorialContent, setTutorialContent] = useState(null);
  const [tutorialLoading, setTutorialLoading] = useState(false);
  const [tutorialContentLoading, setTutorialContentLoading] = useState(false);
  const [tutorialLoadingMore, setTutorialLoadingMore] = useState(false);
  const [tutorialError, setTutorialError] = useState('');
  const [tutorialContentError, setTutorialContentError] = useState('');

  const fetchTutorial = useCallback(async (filter) => {
    const { page, per_page, isLoadingMore } = filter;
    const endpoint = `/v1/tutoriais?page=${page}&limit=${per_page}`;

    if (isLoadingMore) {
      setTutorialLoadingMore(true);
    } else {
      setTutorialLoading(true);
    }

    await customApi(endpoint)
      .then(({ data }) => {
        const tutorialList = [];
        const { targetPage, templateData, total_count } = data;
        Object.entries(templateData.tutoriais).forEach(([key, value]) => {
          tutorialList.push({
            id: key,
            ...value,
          });
        });

        setTutorial({
          pageTitle: targetPage,
          tutorials: tutorialList,
          total: total_count,
        });
      })
      .catch(({ response }) => {
        setTutorialError(response.error);
      });

    if (isLoadingMore) {
      setTutorialLoadingMore(false);
    } else {
      setTutorialLoading(false);
    }
  }, []);

  const fetchTutorialContent = useCallback(async (slug) => {
    setTutorialContentLoading(true);

    await customApi(`/v1/tutoriais/${slug}`)
      .then(({ data }) => {
        setTutorialContent(data.templateData.tutoriais);
      })
      .catch(({ response }) => {
        setTutorialContentError(response.error);
      });
    setTutorialContentLoading(false);
  }, []);

  return {
    fetchTutorial,
    fetchTutorialContent,
    tutorial,
    tutorialContent,
    tutorialLoading,
    tutorialLoadingMore,
    tutorialContentLoading,
    tutorialError,
    tutorialContentError,
  };
};

export default useFetchTutorial;
